import React, { useState } from 'react';
import { OverviewWrapper, SectionHeader } from '../styled';
import { useLocale } from 'locale';
import { H3, Text, SmallText, HrefText } from 'ds/components/typography';
import styled from '@emotion/styled';

const DESCRIPTION_COLLAPSED_LIMIT = 310;

const ShowMore = styled(SmallText)`
  margin-top: ${({ theme }) => theme.spacing(1)};
  cursor: pointer;
`;

interface OverviewSectionProps {
  description: string;
  areaCityName?: string;
  areaNeighbourhoodName?: string;
}

export const OverviewSection: React.FC<OverviewSectionProps> = ({
  description,
  areaCityName = null,
  areaNeighbourhoodName = null,
}) => {
  const { t } = useLocale();
  const [ isCollapsed, setIsCollapsed ] = useState(description && description.length > DESCRIPTION_COLLAPSED_LIMIT);
  return (
    <OverviewWrapper>
      <SectionHeader>
        <H3 weight="bold">{t('localPage.overview.title', { areaName: areaCityName || areaNeighbourhoodName, isCityPage: !!areaCityName })}</H3>
      </SectionHeader>
      {description ? (
        <>
          <Text dangerouslySetInnerHTML={{ __html: isCollapsed ? description.slice(0, DESCRIPTION_COLLAPSED_LIMIT) + '...' : description }} />
          {isCollapsed ? (
            <ShowMore onClick={() => setIsCollapsed(false)}>
              <HrefText>
                <SmallText weight="medium">
                  {t('localPage.description.showMore')}
                </SmallText>
              </HrefText>
            </ShowMore>
          ) : null}
        </>
      ) : null}
    </OverviewWrapper>
  );
};
